export const isFacebookSDKLoaded = () => window.FB !== undefined;
export const isFacebookUserLogedIn = () => window.FB.getAuthResponse();
export const loginWithFacebookSdk = async (callback, config_id, extraConfig = {}) => {
    window.FB.login((response) => {
        callback(response);
    }, {
        config_id,
        ...extraConfig,
    })
};

export const checkLoginStatus = (onUserConnected, onUserDisconnected = () => { }) => {
    window.FB.getLoginStatus(function (response) {
        if (response.status === 'connected') {
            onUserConnected(response.authResponse.accessToken);
        } else {
            onUserDisconnected();
        }
    });
};

export const fbLogout = async () => {
    return new Promise((resolve, reject) => {
        try {

            const accessToken = window.FB.getAccessToken();
            if (!accessToken) {
                console.log('User is not logged in via Facebook');
                resolve(false);
                return;
            }

            window.FB.logout((response) => {
                if (response.status === 'connected') {
                    reject(new Error('Facebook logout failed'));
                } else {
                    console.log('User successfully logged out from Facebook');
                    resolve(true);
                }
            });
        } catch (error) {
            console.error('Facebook logout error:', error.message);
            reject(error);
        }
    });
};